<ng-container>
  <div class="live-page">
    <!-- Page header -->
    <div class="live-pagehead" *ngIf="!selectedChatView || !isMobile">
      <h1 class="page-title">Chat en vivo</h1>
      <button class="live-btn live-btn--outline" (click)="showPlansDialogPreferences = true">
        <i class="pi pi-cog" aria-hidden="true"></i>
        Preferencias
      </button>
    </div>

    <!-- No conversations -->
    <ng-container *ngIf="!records || records.length === 0">
      <globot-no-info message="No tienes conversaciones en vivo para tomar"></globot-no-info>
    </ng-container>

    <!-- Main card -->
    <div
      class="live-card"
      *ngIf="records && records.length > 0"
      [class.is-3col]="selectedChatView && showCustomerPanel && !isMobile"
    >
      <!-- ── Sidebar ─────────────────────────────── -->
      <aside
        class="live-sidebar"
        aria-label="Lista de conversaciones"
        *ngIf="!selectedChatView || !isMobile"
      >
        <div class="live-search">
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="m21 21-4.3-4.3" stroke-linecap="round" />
          </svg>
          <input
            placeholder="Buscar conversación…"
            [(ngModel)]="searchTerm"
            aria-label="Buscar conversación"
          />
        </div>
        <div class="live-filters" *ngIf="!isMobile">
          <button
            *ngFor="let f of channelFilters"
            class="live-chip"
            [class.is-on]="channelFilter === f"
            (click)="channelFilter = f"
          >
            {{ f }}
          </button>
        </div>
        <div class="live-filters-mobile" *ngIf="isMobile">
          <p-dropdown
            [options]="channelOptions"
            [(ngModel)]="channelFilter"
            optionLabel="label"
            optionValue="value"
            [style]="{ width: '100%' }"
            appendTo="body"
          >
          </p-dropdown>
        </div>
        <div class="live-listmeta">
          <span
            >{{ filteredByChannel.length }}
            {{ filteredByChannel.length === 1 ? 'conversación' : 'conversaciones' }}</span
          >
          <span class="live-sort"
            >Más reciente
            <svg
              viewBox="0 0 24 24"
              width="13"
              height="13"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M12 5v14M19 12l-7 7-7-7" />
            </svg>
          </span>
        </div>
        <div class="live-list">
          <globot-conversation-cards
            [records]="filteredByChannel | searchFilter : searchTerm"
            (chatHistorySelected)="onChatHistorySelected($event)"
          >
          </globot-conversation-cards>
        </div>
      </aside>

      <!-- ── Thread: empty state ─────────────────── -->
      <section class="live-thread live-thread--empty" *ngIf="!selectedChatView && !isMobile">
        <globot-information-section
          title="Responde en tiempo real con Chat en vivo"
          message="Gestiona las consultas de tus clientes desde todos tus canales en un solo lugar. Selecciona una conversación de la lista para interactuar."
        >
        </globot-information-section>
      </section>

      <!-- ── Thread: active chat ─────────────────── -->
      <section class="live-thread" *ngIf="selectedChatView">
        <!-- Thread header -->
        <div class="live-thread-head">
          <div class="live-thread-id">
            <button
              *ngIf="isMobile"
              class="live-icon-btn"
              aria-label="Volver a la lista de conversaciones"
              (click)="
                selectedChatView = false;
                selectedChat = undefined;
                selectedChatHistory = [];
                userInControl = false
              "
            >
              <i class="pi pi-arrow-left" aria-hidden="true"></i>
            </button>
            <div
              class="live-chan-av"
              [style.background]="getChannelColor(selectedChat?.channel || '')"
            >
              <i
                [class]="getChannelIcon(selectedChat?.channel || '') + ' live-chan-icon'"
                aria-hidden="true"
              ></i>
            </div>
            <div>
              <div class="live-thread-name">{{ selectedChat?.name || 'Anónimo' }}</div>
              <div class="live-thread-sub">{{ getChannelLabel(selectedChat?.channel || '') }}</div>
            </div>
          </div>
          <!-- Desktop: mostrar cuando panel cerrado -->
          <button
            *ngIf="!isMobile && !showCustomerPanel"
            class="live-icon-btn"
            aria-label="Ver datos del cliente"
            (click)="showCustomerPanel = true"
            pTooltip="Ver datos del cliente"
            tooltipPosition="top"
          >
            <i class="pi pi-user" aria-hidden="true"></i>
          </button>
          <!-- Mobile: siempre visible, abre modal de edición -->
          <button
            *ngIf="isMobile"
            class="live-icon-btn"
            aria-label="Editar datos del cliente"
            (click)="showPlansDialog = true"
          >
            <i class="pi pi-user" aria-hidden="true"></i>
          </button>
        </div>

        <!-- Messages scroll -->
        <div class="live-scroll message scrollable">
          <!-- GLOB-1888: conversación abierta sin mensajes recuperables. Antes el panel
               quedaba en blanco, sin estado vacío ni error. -->
          <div class="live-thread-nomsg" *ngIf="selectedChatHistory.length === 0">
            <i class="pi pi-inbox" aria-hidden="true"></i>
            <p>Esta conversación no tiene mensajes disponibles</p>
          </div>
          <div *ngFor="let group of selectedChatHistory; trackBy: trackByGroupDate">
            <div class="live-datesep">
              <span>{{ group.date }}</span>
            </div>
            <div *ngFor="let message of group.messages.slice(); trackBy: trackByIndex">
              <!-- Customer message -->
              <div *ngIf="message.user_prompt" class="live-row live-row--in">
                <div class="live-bubble live-bubble--in">{{ message.user_prompt }}</div>
                <div class="live-meta">
                  {{ message.name || 'Anónimo' }} | {{ message.created_at | date : 'HH:mm' }}
                </div>
              </div>

              <!-- Bot / agent response -->
              <div *ngIf="message.response" class="live-row live-row--out">
                <div
                  class="live-bubble"
                  [class.live-bubble--bot]="message.answered_by !== 'USER'"
                  [class.live-bubble--agent]="message.answered_by === 'USER'"
                >
                  <span class="live-bubble-tag" *ngIf="message.answered_by === 'USER'">
                    <span class="live-dot-live"></span
                    >{{ message.user_in_control?.name || 'Agente' }}
                  </span>
                  <div [innerHTML]="formatMessage(message.response)"></div>
                  <div
                    *ngIf="
                      message.response_feedback !== null && message.response_feedback !== undefined
                    "
                    class="live-feedback"
                  >
                    <svg
                      *ngIf="message.response_feedback === true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      stroke="none"
                      aria-hidden="true"
                    >
                      <path d="M7 10v12" />
                      <path
                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                      />
                    </svg>
                    <svg
                      *ngIf="message.response_feedback === false"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      stroke="none"
                      aria-hidden="true"
                    >
                      <path d="M17 14V2" />
                      <path
                        d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
                      />
                    </svg>
                  </div>
                </div>
                <div class="live-meta live-meta--out">
                  <span *ngIf="message.answered_by === 'USER'">{{
                    message.user_in_control?.name || 'Agente'
                  }}</span>
                  <span *ngIf="message.answered_by !== 'USER'">Asistente</span>
                  | {{ message.created_at | date : 'HH:mm' }}
                </div>
              </div>
            </div>
          </div>

          <!-- Meta 24h limit notice (inside scroll) -->
          <div
            *ngIf="isLiveMessagingReady && selectedChatHistory.length > 0 && isMetaLimitExceeded()"
            class="live-meta-limit"
          >
            <i
              class="pi pi-info-circle"
              style="color: #c18c30; font-size: 18px; flex-shrink: 0; margin-top: 2px"
              aria-hidden="true"
            ></i>
            <div>
              <b>Tiempo de respuesta superado</b>
              <p>
                Tienes hasta 24 horas para responderle a tus clientes a través de los canales de
                mensajería de Meta. Puedes esperar a que el cliente vuelva a escribir o contactarlo
                por otro canal.
              </p>
            </div>
          </div>
        </div>

        <!-- Footer dock -->
        <div class="live-footer" *ngIf="isLiveMessagingReady && selectedChatHistory.length > 0">
          <!-- IA en control: dock con botón Intervenir -->
          <div class="live-dock" *ngIf="!userInControl && !isMetaLimitExceeded()">
            <div class="live-dock-state">
              <span class="live-dock-ic"
                ><img src="assets/icons/globot-icon.svg" width="26" height="26" alt="Globot"
              /></span>
              <div>
                <b>Globot está atendiendo esta conversación</b>
                <span class="live-dock-sub">Haz clic en "Intervenir" si quieres responder tú.</span>
              </div>
            </div>
            <button
              class="live-btn live-btn--primary"
              (click)="takeControl(true)"
              [disabled]="loadingButton"
            >
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M9 11V6a3 3 0 0 1 6 0v5" />
                <path
                  d="M5 11h14a2 2 0 0 1 2 2v1a7 7 0 0 1-7 7h-4a7 7 0 0 1-7-7v-1a2 2 0 0 1 2-2Z"
                />
              </svg>
              {{ loadingButton ? 'Tomando el control…' : 'Intervenir' }}
            </button>
          </div>

          <!-- Agente en control: barra verde + compositor -->
          <div class="live-footer-agent" *ngIf="userInControl && !isMetaLimitExceeded()">
            <div class="live-livebar">
              <span class="live-livebar-l" *ngIf="!isMobile">
                <span class="live-dot-live"></span>
                Estás respondiendo tú
                <span class="live-livebar-name">· {{ user?.name || 'Agente' }}</span>
              </span>
              <button
                class="live-link"
                [class.live-link--mobile]="isMobile"
                (click)="takeControl(false)"
              >
                <img
                  src="assets/icons/globot-icon.svg"
                  [width]="isMobile ? 22 : 14"
                  [height]="isMobile ? 21 : 13"
                  alt="Globot"
                />
                Devolver a la IA
              </button>
            </div>
            <div class="live-composer">
              <input
                type="text"
                placeholder="Escribe un mensaje…"
                [(ngModel)]="currentQuestion"
                (keyup.enter)="sendAnswer()"
              />
              <button
                class="live-send"
                aria-label="Enviar mensaje"
                (click)="sendAnswer()"
                [disabled]="!currentQuestion.trim()"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="m22 2-7 20-4-9-9-4Z" />
                  <path d="M22 2 11 13" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Nota cuando hay bloqueo 24h y el agente intervino -->
          <div class="live-footer-note" *ngIf="isMetaLimitExceeded() && userInControl">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span
              >No puedes responder: pasaron más de 24 h desde el último mensaje del cliente.</span
            >
          </div>
        </div>
      </section>

      <!-- ── Customer panel ─────────────────────── -->
      <aside
        class="live-cust"
        aria-label="Datos del cliente"
        *ngIf="selectedChatView && showCustomerPanel && !isMobile"
      >
        <div class="live-cust-head">
          <span>Datos del cliente</span>
          <button class="live-icon-btn" (click)="showCustomerPanel = false" aria-label="Cerrar">
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="live-cust-id">
          <div
            class="live-chan-av live-chan-av--lg"
            [style.background]="getChannelColor(selectedChat?.channel || '')"
          >
            <i
              [class]="
                getChannelIcon(selectedChat?.channel || '') + ' live-chan-icon live-chan-icon--lg'
              "
              aria-hidden="true"
            ></i>
          </div>
          <div>
            <div class="live-cust-name">{{ selectedChat?.name || 'Anónimo' }}</div>
            <div class="live-cust-channel">{{ getChannelLabel(selectedChat?.channel || '') }}</div>
          </div>
        </div>
        <hr class="live-divider" />
        <dl class="live-cust-fields">
          <div>
            <dt>Primera visita</dt>
            <dd>{{ selectedChat?.created_at | date : 'dd MMM yyyy' }}</dd>
          </div>
          <div *ngIf="selectedChat?.email">
            <dt>Email</dt>
            <dd>{{ selectedChat?.email }}</dd>
          </div>
          <div *ngIf="selectedChat?.phone">
            <dt>Teléfono</dt>
            <dd>{{ selectedChat?.phone }}</dd>
          </div>
          <div *ngIf="selectedChat?.sender_requirement">
            <dt>Notas</dt>
            <dd class="live-cust-notes">{{ selectedChat?.sender_requirement }}</dd>
          </div>
        </dl>
        <div class="live-cust-tags">
          <span class="live-pill" *ngIf="selectedChat?.channel">{{
            getChannelLabel(selectedChat?.channel || '')
          }}</span>
          <span class="live-pill" *ngIf="selectedChat?.user_in_control">Agente activo</span>
        </div>
        <button class="live-btn live-btn--outline live-btn--block" (click)="showPlansDialog = true">
          Editar datos del cliente
        </button>
      </aside>
    </div>
    <!-- /live-card -->
  </div>
  <!-- /live-page -->

  <!-- Dialog: datos de cliente -->
  <p-dialog
    header="Datos de cliente"
    [modal]="true"
    [style]="{ maxWidth: '34rem' }"
    [(visible)]="showPlansDialog"
    [resizable]="false"
    [draggable]="false"
    class="modal-user"
  >
    <globot-customer-form
      (saved)="showPlansDialog = false"
      (cancelled)="showPlansDialog = false"
    ></globot-customer-form>
  </p-dialog>

  <!-- Dialog: preferencias -->
  <p-dialog
    header="Preferencias"
    [modal]="true"
    [style]="{ maxWidth: '40rem' }"
    [(visible)]="showPlansDialogPreferences"
    [resizable]="false"
    [draggable]="false"
    class="modal-preferencias"
  >
    <globot-preferences-box
      [botId]="botId"
      (preferencesSaved)="onPreferencesSaved($event)"
      (preferenceCancelled)="onPreferencesCancelled()"
    >
    </globot-preferences-box>
  </p-dialog>
</ng-container>
